import React, { useCallback } from "react";
import Histogram from "../Graphs/Histogram";
import LollipopPlot from "../Graphs/LollipopPlot";
import  PieChart  from "../Graphs/PieChart";
import  DonutChart  from "../Graphs/DonutChart";
import CircleBarplot  from "../Graphs/CircleBarPlot";
import DensityPlot from "../Graphs/DensityPlot";
import Ridgeline  from "../Graphs/Ridgeline";
import BoxPlot from "../Graphs/BoxPlot";
import ScatterPlot from "../Graphs/ScatterPlot";
import HexbinPlot from "../Graphs/HexbinPlot";
import { Responsive, WidthProvider } from "react-grid-layout";
import { WarningAlert } from "../../../alerts/WarningAlert";
import { useMutation } from "@apollo/client";
import { DELETE_GRAPH } from "../../../Querys/reports/querys";
import { SuccessfulAlert } from "../../../alerts/successAlerts";
import { ErrorAlert } from "../../../alerts/errorAlert";
import styles from "../Graphs/piechart.module.css";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const graphComponents: { [key: string]: React.ComponentType<any> } = {
  histogram: Histogram,
  lollipop: LollipopPlot,
  pie: PieChart,
  donut: DonutChart,
  circularBar: CircleBarplot,
  density: DensityPlot,
  rid: Ridgeline,
  box: BoxPlot,
  scatter: ScatterPlot,
  density2d: HexbinPlot,
};

interface GraphDataItem {
  graphType: string;
  dataToGraph: string;
  name: string;
  id: number;
  informeStatus: string;
  xLimMax: number;
  xLimMin: number;
  yLimMax: number;
  yLimMin: number;
}

interface GraphMapperProps {
  graphsData: GraphDataItem[];
  refetch: any
}

const GraphMapper: React.FC<GraphMapperProps> = ({ graphsData, refetch }) => {
  const [deleteGraphMutation] = useMutation(DELETE_GRAPH);

  const deleteGraph= async (id:number) => {
    let response = await WarningAlert({ text: "¿Deseas eliminar este gráfico?", showDenyButton: true, confirmButtonText: "Eliminar" });
    if (response.isConfirmed) {
       try{
          await deleteGraphMutation({
            variables: {
              deleteGraphId: id
            }
          })
          refetch();
          await SuccessfulAlert({ text: "Gráfico eliminado correctamente." })
       }
       catch(e){
        ErrorAlert({ text: 'Ocurrió un error al intentar eliminar este gráfico.' })
       }
    }
  }
  
  const renderGraph = useCallback((item: GraphDataItem, index: number) => {
    const GraphComponent = graphComponents[item.graphType];
    if (!GraphComponent) {
      return (
        <div key={item.id} style={{ backgroundColor: "white", alignContent: 'center' }}
        data-grid={{
          i: item.id.toString(), 
          x: 0,
          y: 0,
          w: 6,
          h: 4,
          minW: 4,
          minH:3,}}
        >
          <div style={{textAlign: 'center', fontSize: '20px'}}>
           Algo salió mal... 😪 
          </div>
        </div>
      );
    }

    if(item.informeStatus !== 'ACTIVO'){
      return (
        <div key={item.id} style={{ backgroundColor: "white", alignContent: 'center' }}
        data-grid={{
          i: item.id.toString(), 
          x: 0,
          y: 0,
          w: 6,
          h: 4,
          minW: 4,
          minH:3,}}>
           <div style={{textAlign: 'center', fontSize: '20px'}}>
            El informe relacionado con este gráfico ha sido eliminado.
           </div>
           <span
          className="remove"
          style={{position: 'absolute', right: '2px', top:'0', cursor:'pointer'}}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={()=>deleteGraph(item.id)}
          >
          <button className="CreateReports_closeModalButton">
            <img src="/../../../assets/svg/CloseM.svg"></img>
          </button>
          </span>
        </div>
      )
    }

    const dataNom = JSON.parse(item.dataToGraph);


    return (
      <div className={styles.grafico} key={item.id} style={{ backgroundColor: "white", width:'100%', height:'100%', margin:'3px'}}
        data-grid={{
          i: item.id.toString(), 
          x: 0,
          y: 0,
          w: 6,
          h: 4,
          minW: 4,
          minH:3,}}>
        <GraphComponent key={`${item.id}_${item.graphType}`} data={dataNom} title={item.name} xLimMax={item.xLimMax} xLimMin={item.xLimMin} yLimMax={item.yLimMax} yLimMin={item.yLimMin} />
        <span
          className={styles.remove}
          style={{position: 'absolute', right: '2px', top:'0', cursor:'pointer'}}
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={()=>deleteGraph(item.id)}
        >
          <button className={styles.delete_button} type="button">
            &times;
          </button>
        </span>        
      </div>
    );
  }, [graphsData]);

  return (
    <ResponsiveReactGridLayout
      className="layout"
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
      cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
      rowHeight={80}
      margin={[20, 20]}
      containerPadding={[30,30]}
    >
      {graphsData.map((item, index) => renderGraph(item, index))}
    </ResponsiveReactGridLayout>
  );
};

export default GraphMapper;